import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Icons } from 'src/app/models/icons.model';
import { SiteModel } from 'src/app/models/site.model';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-admin-site',
  standalone: false,
  templateUrl: './admin-site.component.html',
  styleUrls: ['./admin-site.component.scss'],
})
export class AdminSiteComponent implements OnInit, OnDestroy {
  // Event Handlers
  private adminLoadedEventHandler: Subscription;

  filteredSites: Observable<SiteModel[]>;
  filter = new UntypedFormControl('');
  icons = new Icons();

  constructor(public adminService: AdminService) { }

  ngOnInit(): void {
    if (!this.adminService.isReady) {
      this.adminLoadedEventHandler = this.adminService.adminServiceLoadedEvent.subscribe(
        () => {
          this.initSearch();
        }
      );
    } else {
      this.initSearch();
    }
  }

  ngOnDestroy() {
    if (this.adminLoadedEventHandler)
      this.adminLoadedEventHandler.unsubscribe();
  }

  // Search
  private initSearch() {
    this.filteredSites = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.searchSites(text))
    );
  }

  clearSearch() {
    this.filter.setValue('');
  }

  private searchSites(text: string): SiteModel[] {
    return this.adminService.sites?.filter((user) => {
      const term = text.toLowerCase();
      return user.Name?.toLowerCase().includes(term);
    });
  }
}
